import { SectionTitle } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { getExerciseIconSrc } from '../../assets';
import { SKELETON_CLASSNAME, SKELETON_DUMMYTEXT } from '../../base/constants';
import { isChallengeWorkoutId } from '../../base/utils';
import { SessionSelectors } from '../../session';
import { IState } from '../../store/state';
import * as Selectors from '../selectors';
import './TutorialView.scss';

export interface ITutorialViewProps {
  exerciseId: string | null;
  isChallenge: boolean;
}

export const TutorialViewFC: React.FC<ITutorialViewProps> = ({ exerciseId, isChallenge }) => {
  const { t, language } = useTranslation();

  const isLoading = exerciseId === null || !language;
  const skeletonClass = isLoading ? SKELETON_CLASSNAME : '';
  const challengePostfix = isChallenge ? 'Challenge' : '';
  const exerciseTitle = isLoading ? SKELETON_DUMMYTEXT : t(`common.exercises:Title.${exerciseId}${challengePostfix}`);

  const titleClasses = `exercise-title ${skeletonClass}`;
  const tutorialText = isLoading ? SKELETON_DUMMYTEXT : t(`Exercise.Tutorial.${exerciseId}`);
  const tutorialClasses = `exercise-tutorial ${skeletonClass}`;
  const exerciseIconSrc = exerciseId ? getExerciseIconSrc(exerciseId) : undefined;
  const exerciseIconAlt = isLoading ? SKELETON_DUMMYTEXT : `${exerciseTitle} exercise icon`;
  const exerciseIconClass = `tutorial-illustration ${skeletonClass}`;
  return (
    <div className="slide-view tutorial-view">
      <div className="slide-content">
        <SectionTitle className={titleClasses}>{exerciseTitle}</SectionTitle>
        <div className="slide-text">
          <p className={tutorialClasses}>{tutorialText}</p>
        </div>
      </div>
      <div className="slide-illustration tutorial-icon-container">
        <img src={exerciseIconSrc} alt={exerciseIconAlt} className={exerciseIconClass} />
      </div>
    </div>
  );
};

export const mapStateToProps = (state: IState) => {
  const workoutId = Selectors.getWorkoutId(state);
  const exerciseId = SessionSelectors.getExerciseName(state, workoutId);
  const isChallenge = isChallengeWorkoutId(workoutId);
  return {
    exerciseId,
    isChallenge,
  };
};

const TutorialView = connect(mapStateToProps)(TutorialViewFC);
export default TutorialView;
